module.exports = __webpack_public_path__ + "static/media/ivc-logo.34f54a18.svg";